<template>
  <div>
    <b-modal
      id="user-accessibility-modal"
      ref="modalRef"
      title="Find user"
      hide-footer
      @hidden="onHidden"
    >
      <b-form-group label="Phone Number">
        <b-input-group>
          <b-input-group-prepend class="d-flex align-items-center mr-1">
            +962
          </b-input-group-prepend>
          <b-form-input
            v-model.number="phoneNo"
            type="number"
            placeholder="Enter user phone number"
            autofocus
          />
        </b-input-group>
      </b-form-group>
      <h4
        v-if="noUserFound"
        class="text-danger text-center"
      >
        No user found with this phone number
      </h4>
      <div
        v-else-if="foundUser"
        class="d-flex justify-content-between align-items-center mb-1"
      >
        <span>User Name: {{ foundUser.firstName + " " + foundUser.lastName }}</span>
        <b-button
          variant="success"
          small
          @click="redirectToDetails"
        >
          Go to details
        </b-button>
      </div>
      <b-button
        block
        :disabled="!phoneNo || searching"
        variant="primary"
        @click="searchUser"
      >
        <b-spinner
          v-if="searching"
          small
        />
        <span v-else>Search user</span>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api'
import {
  BModal,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BInputGroupPrepend,
  BInputGroup,
} from 'bootstrap-vue'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    BInputGroupPrepend,
    BInputGroup,
  },
  setup(_, ctx) {
    const phoneNo = ref('')
    const searching = ref(false)
    const noUserFound = ref(false)
    const foundUser = ref(null)
    const searchUser = async () => {
      try {
        foundUser.value = null
        noUserFound.value = false
        searching.value = true
        const result = await axiosIns.get('/users', {
          params: {
            text: `+962${phoneNo.value}`,
          },
        })
        console.log(result)
        noUserFound.value = !result.data.data.users.length
        // eslint-disable-next-line prefer-destructuring
        foundUser.value = result.data.data.users[0]
      } catch (err) {
        errorNotification('Try again')
      } finally {
        searching.value = false
      }
    }

    const inst = getCurrentInstance()
    const redirectToDetails = () => {
      inst.refs.modalRef.hide()
      ctx.root.$router.push({
        path: `/users/${foundUser.value.id}`,
        query: { externalId: foundUser.value.externalId },
      })
    }

    const onHidden = () => {
      phoneNo.value = ''
      noUserFound.value = false
      foundUser.value = null
    }

    return {
      redirectToDetails,
      foundUser,
      noUserFound,
      onHidden,
      searchUser,
      searching,
      phoneNo,
    }
  },
}
</script>

<style></style>
